<template>
  <div>

    <BreadCrumbs 
      :children="[
        {
          text: 'Reporte de ordenes',
        }
      ]"/>

    <!-- FILTROS -->
    <div class="card ml-2 mr-2" id="filters">
      <div class="card-body">
        <div class="row">
          <div class="col-md-3 col-sm-12">
            <label for="date-to">Sucursal</label>
            <select :disabled="loading" v-model="filters.branchOfficeId" placeholder="Sucursal" class="form-control">
              <option value="">-Seleccione-</option>
              <option v-for="x in branchOffices" :key="x.id" :value="x.id">{{ x.name }}</option>
            </select>
          </div>
          <div class="col-md-3 col-sm-12">
            <label for="date-from">Fecha desde</label>
            <input :disabled="loading" v-model="filters.from" type="date" placeholder="Fecha desde" id="date-from" class="form-control">
          </div>
          <div class="col-md-3 col-sm-12">
            <label for="date-to">Fecha hasta</label>
            <input :disabled="loading" v-model="filters.to" type="date" placeholder="Fecha hasta" id="date-to" class="form-control">
          </div>
          <div class="col-md-3 col-sm-12">
            <label for="date-to">Tipo de pago</label>
            <select :disabled="loading" v-model="filters.paymentType" class="form-control">
              <option value="">-Todos-</option>
              <option value="1">Transferencia</option>
              <option value="3">Tarjeta</option>
            </select>
          </div>
          <div class="col-md-2 col-sm-12">
            <button :disabled="loading" @click="getReport" class="btn btn-primary mt-4">
              <span v-if="loading">Generando...</span>
              <span v-else><i class="fa fa-line-chart"></i> Generar</span>
            </button>
          </div>
          <div class="col-md-10 col-12 totals-resume mt-3" style="display: flex;" v-if="reportReady">
            <table class="resume">
              <tr>
                <td class="w195"><b>Ordenes:</b></td>
                <td class="w50">{{ orders.length | number }}</td>
              </tr>
              <tr v-if="$store.getters.isAdmin">
                <td class="w195"><b>Total envío (USD):</b></td>
                <td class="w50">${{ shippingTotal | money }}</td>
              </tr>
              <tr v-if="$store.getters.isAdmin">
                <td class="w195"><b>Total en cupones (USD):</b></td>
                <td :style="{fontWeight: couponTotal > 0 ? 'bold' : 'normal'}" :class="couponTotal > 0 ? 'w50 text-danger bold' : 'w50'">${{ couponTotal | money }}</td>
              </tr>
              <tr>
                <td class="w195"><b>Total en productos:</b></td>
                <td class="w50">${{ productsTotalRD | money }}</td>
              </tr>
              <tr v-if="$store.getters.isAdmin">
                <td class="w195"><b>Total general (USD):</b></td>
                <td class="w50">${{ ordersTotal | money }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- TABLA -->
    <div class="card ml-2 mr-2" v-if="reportReady">
      <div class="text-left pl-3 pt-1">
        <button class="btn main-bg" @click="exportToExcel()"><i class="fa fa-download"></i> Exportar</button>
      </div>
      <div class="card-body scrollable report">
        <div class="table-responsive">
          <table class="table table-condensed table-responsive report-table">
            <thead class="thead-light">
              <tr>
                <th>Número</th>
                <th>Cliente</th>
                <th>Fecha</th>
                <th>Nota</th>
                <th>Recojida</th>
                <th>Entrega</th>
                <th>Provincia</th>
                <th>Proveedor de pago</th>
                <th># Transacción</th>
                <th v-if="$store.getters.isAdmin">Total (USD)</th>
                <th>Total (RD)</th>
                <th v-if="$store.getters.isAdmin">Cargo de envío</th>
                <th v-if="$store.getters.isAdmin">Total en cupón</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="x in orders" :key="x.id">
                <td>{{ x.number }}</td>
                <td>{{ x.client }}</td>
                <td>{{ x.confirmationDate }}</td>
                <td :title="x.note">{{ shopWord(x.note, 20) }}</td>
                <td :title="x.pointA">{{ shopWord(x.pointA, 20) }}</td>
                <td :title="x.pointB">{{ shopWord(x.pointB, 20) }}</td>
                <td>{{ x.province }}</td>
                <td>{{ x.paymentType == 1 ? 'Transferencia' : 'Tarjeta' }}</td>
                <td>{{ x.transactionNumber }}</td>
                <td v-if="$store.getters.isAdmin">{{ x.totals.total | money }}</td>
                <td>{{ x.totals.totalRD | money }}</td>
                <td v-if="$store.getters.isAdmin">{{ x.totals.shipping | money }}</td>
                <td v-if="$store.getters.isAdmin">{{ x.totals.totalInCoupon | money }}</td>
              </tr>
              <tr v-if="orders.length === 0">
                <td colspan="14" class="text-center">
                  <h4>No hay ordenes</h4>
                </td>
              </tr>
            </tbody>

          </table>

        </div>
      </div>
    </div>

    <div class="text-center" v-if="loading">
      <Loader />
    </div>

  </div>
</template>
<script>
import firebase from 'firebase/app'
import BreadCrumbs from '../components/Breadcrumbs'
import DateHelper from '../../commons/DateHelper'
import Loader from '../components/Loader'
import {OrdersService} from '../../services/OrdersService'
export default {
  name: 'OrdersReport',
  components: {BreadCrumbs, Loader},
  data: function(){
    return {
      orders: [],
      branchOffices: [],
      loading: false,
      reportReady: false,
      filters: {
        from: '',
        to: '',
        paymentType: '',
        branchOfficeId: '',
      },
      rate: '',
      ordersService: new OrdersService()
    }
  },
  methods: {
    shopWord(word, count){
      if(!word){
        return '';
      }
      if(word.length <= count){
        return word;
      }
      return `${String(word).substring(0, count)}...`;
    },
    exportToExcel(){
      if(this.orders.length === 0){
        return;
      }
      const data = [];
      this.orders.forEach((o) => {
        data.push([
          o.number,
          o.client,
          this.branchOfficeName,
          o.date,
          o.note,
          o.pointA,
          o.pointB,
          o.province,
          o.paymentProvider,
          o.transactionNumber,
          o.totals.total,
          o.totals.shipping,
          o.totals.totalInCoupon,
        ]);
      });

      data.unshift([
        "Número de orden",
        "Cliente",
        "Sucursal",
        "Fecha",
        "Nota",
        "Recojida",
        "Entrega",
        "Provincia",
        "Proveedor de pago",
        "Número de transacción",
        "Total",
        "Cargo de envío",
        "Total en cupón",
      ]);
      this.$helpers.exportToCsv(`Reporte de ordenes Domicanasta (${this.branchOfficeName}).csv`, data);
    },
    async getReport(){
      if(this.filters.branchOfficeId === ''){
        this.$helpers.message('Faltan campos', 'La sucursal es requerida', 'warning');
        return;
      }
      if(this.filters.from === ''){
        this.$helpers.message('Faltan campos', '(Fecha desde) es requerida', 'warning');
        return;
      }
      if(this.filters.to === ''){
        this.$helpers.message('Faltan campos', '(Fecha hasta) es requerida', 'warning');
        return;
      }
      const timestampFrom = DateHelper.getTimestampFromDate(this.filters.from);
      const timestampTo = DateHelper.getTimestampFromDate(this.filters.to);

      if(timestampFrom > timestampTo){
        this.$helpers.message('Filtro invalido', '(Fecha desde) no puede ser posteriror a (Fecha hasta)', 'warning');
        return;
      }
      this.loading = true;
      this.reportReady = false;

      try {
        this.orders = [];
        const resp = await this.ordersService.getReport(
          this.filters.branchOfficeId,
          timestampFrom,
          timestampTo,
          Number(this.filters.paymentType)
        );

        if(resp.ok === true){
          this.orders = resp.data;
          this.reportReady = true;
        }else{
          this.$helpers.message('Error', resp.message, 'error');
        }
      } catch (error) {
        console.log('err ',error);
        this.$helpers.message('Error', 'Algo salio mal', 'error');
      }
      this.loading = false;
    },
  },
  mounted: async function(){
    this.loading = true;
    let list = [];
    if(this.$store.getters.isAdmin == false){
      if(Array.isArray(this.$store.getters.getCompany)){
        list = await firebase
        .firestore()
        .collection('BranchOffices')
        .where('company_id', 'in', this.$store.getters.getCompany)
        .get();
      }else{
        list = await firebase
        .firestore()
        .collection('BranchOffices')
        .where('company_id', '==', this.$store.getters.getCompany)
        .get();
      }

    }else{
      list = await firebase.firestore().collection('BranchOffices').get();
    }
    list.docs.forEach(doc => {
      this.branchOffices.push({
        id: doc.id,
        name: doc.data().name,
      });
    });
    this.loading = false;
  },
  computed: {
    branchOfficeName(){
      return this.branchOffices.find(x => x.id === this.filters.branchOfficeId).name;
    },
    ordersTotal(){
      return Number(this.orders.reduce((acc, cur) => acc + Number(cur.totals.total), 0)).toFixed(2);
    },
    productsTotal(){
      return Number(this.orders.reduce((acc, cur) => acc + Number(cur.totals.products), 0)).toFixed(2);
    },
    productsTotalRD(){
      return Number(this.orders.reduce((acc, cur) => acc + Number(cur.totals.totalRD), 0)).toFixed(2);
    },
    shippingTotal(){
      return Number(this.orders.reduce((acc, cur) => acc + Number(cur.totals.shipping), 0)).toFixed(2);
    },
    couponTotal(){
      return Number(this.orders.reduce((acc, cur) => acc + Number(cur.totals.totalInCoupon), 0)).toFixed(2);
    }
  }
}
</script>
<style scoped>

table {
  table-layout: fixed;
  font-weight: 400;
}
.report th,
td {
  font-weight: 400;
  min-width: 110px;
  max-width: 150px;
  overflow: hidden;
  word-wrap: break-word;
}
h4{
  margin: 0;
}
.scrollable{
  max-height: 50vh;
  max-width: 100%;
  overflow: auto;
}
.totals-resume{
  font-size: 15px;
  color: black;
}
tfoot td{
  font-weight: bold;
}
.w195{
  max-width: 195px !important;
  min-width: 160px !important;
}
.w50{
  width: 70px !important;
  min-width: 70px !important;
}
.report-table th,td{
  font-size: 13px;
}
.report-table thead th{
  font-weight: bold;
}
</style>